import { Dispatch, SetStateAction } from 'react';

import { FormikProps } from 'formik';

import { AppDispatch } from '../../../../../../store/models/app-dispatch.model';
import { IdFile } from '../../../../../shared/models/id-file.model';
import { getBlobFile } from '../../../../../shared/thunks/get-blob-file.thunk';
import { appsFilesActions } from '../../../../store/slices/apps-files.slice';
import { getAppDetailsById } from '../../../../thunks/get-app-details-by-id.thunk';
import { appModelToFormik } from '../../../../utils/app-model-to-app-detail-form-formik-model.util';
import { AppDetailFormFormikModel } from '../models/app-detail-form-formik.model';

export const populateAppDetailsForm = (
  applicationId: number,
  formik: FormikProps<AppDetailFormFormikModel>,
  dispatch: AppDispatch,
  setFiles: Dispatch<SetStateAction<IdFile[] | undefined>>,
  setIcon: Dispatch<SetStateAction<IdFile[] | undefined>>
): void => {
  dispatch(getAppDetailsById(applicationId))
    .unwrap()
    .then(data => {
      formik.setValues(appModelToFormik(data));

      dispatch(
        getBlobFile({
          downloadLink: data.icon.downloadLink,
          id: data.icon.id,
          name: data.icon.name,
        })
      )
        .unwrap()
        .then(result => {
          dispatch(appsFilesActions.setIcon(data.icon));
          setIcon([result]);
        });

      Promise.all(
        data.screenshots.map(screenshot => {
          dispatch(appsFilesActions.setScreenshots(screenshot));
          return dispatch(
            getBlobFile({
              downloadLink: screenshot.downloadLink,
              id: screenshot.id,
              name: screenshot.name,
            })
          ).unwrap();
        })
      ).then(result => {
        setFiles(result);
      });
    });
};
